export default __webpack_public_path__ + "static/hero-curve-rfid-21bc4e6efa34f45741bf1ae495bf56a3.png";